<template>
	<el-dialog
    style="z-index:2022 !important;"
    :visible.sync="visibility"
    :modal-append-to-body="false"
    :show-close='false'
    class="xero-choose"
    :close-on-click-modal='false'
    width="840px"
    center
    >
    <div v-if="step === 1">
        <h1 style="margin-bottom:27px">Do you have one venue in your Xero<br />
    organisation?</h1>
        <div class="btn">
            <el-button class="cancel" @click="operateNo">No</el-button>
            <el-button class="confirm" @click="operateYes">Yes</el-button>
        </div>
    </div>
    <div v-if="step === 2 && getDataDone === true && data.length > 0">
        <h1>We found the following tracking categories in<br />
            Xero, If you only want to look at certain<br />
            categories, tick them below. If you want to look at all<br />
            categories, press No.</h1>
        <div class="tree-scroll">
            <el-tree
            ref="tree"
            :data="data"
            show-checkbox
            :default-expanded-keys="defaultExpanded"
            node-key="id"
            :empty-text="' '"
            @check-change="clickEvent">
            </el-tree>
        </div>
        <div class="btn">
            <el-button class="cancel" @click="operateYes">No</el-button>
            <el-button class="confirm" :disabled='chosed.length === 0' @click="getIds">Yes</el-button>
        </div>
    </div>
    <div v-if="step === 2 && getDataDone === true && data.length === 0">
        <h1>No tracking category has been set for this account Continue</h1>
        <div class="btn"><el-button class="confirm" @click="operateYes">Continue</el-button></div>
    </div>
    <div v-if="step === 2 && getDataDone === false" style="text-align:center;font-size:26px;color:var(--text-color);">
        <i class="el-icon-loading"></i> loading ...
    </div>
    </el-dialog>
</template>

<script>
import api from '../../api/xero'

export default {
    props:['visibility'],
    data () {
        return {
            step: 1,
            data: [],
            chosed: [],
            defaultExpanded: [],
            getDataDone: false
        }
    },
    methods: {
        operateNo() {
            var that = this
            this.step = 2
            api.getTrackingCategories({
                callback: (res) => {
                    if (res.data.code == 0) {
                        // that.$emit('close')
                        res.data.data.forEach(item => {
                            let children = []
                            item.Options.forEach(i => {
                                children.push({
                                    id: i.TrackingOptionID,
                                    label: i.Name,
                                    parent: item.TrackingCategoryID
                                })
                            })
                            that.data.push({
                                id: item.TrackingCategoryID,
                                label: item.Name,
                                children: children
                            })
                            that.defaultExpanded.push(item.TrackingCategoryID)
                        })
                        that.getDataDone = true
                        this.$emit('open-category-list', this.data, this.defaultExpanded)
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })
        },
        clickEvent () {
            this.chosed = this.$refs.tree.getCheckedNodes()
        },
        getIds () {
            var that = this
            const node_selected = this.$refs.tree.getCheckedNodes()
            let format_selected = []
            node_selected.forEach(item => {
                if (item.children) {
                    format_selected.push({
                        trackingCategoryID: item.id,
                        name: item.label,
                        options: []
                    })
                } else {
                    let hasParent = false
                    format_selected.forEach(i => {
                        if (i.trackingCategoryID == item.parent) {
                            hasParent = true
                            i.options.push({
                                trackingOptionID: item.id,
                                name: item.label
                            })
                        }
                    })
                    if (!hasParent) {
                        format_selected.push({
                            trackingCategoryID: item.parent,
                            name: item.label,
                            options: [{trackingOptionID: item.id, name: item.label}]
                        })
                    }
                }
            })
            api.saveTrackingCategories({
                params: {categoryList: format_selected},
                callback: (res) => {
                    if (res.data.code == 0) {
                        that.$emit('close')
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })
        },
        operateYes() {
            api.saveTrackingCategories({
                params: {categoryList: []},
                callback: (res) => {
                    if (res.data.code == 0) {
                        this.$emit('close')
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })

        }
    },
    beforeDestroy() {
        this.step = 1
        this.data = []
        this.chosed = []
        this.defaultExpanded = []
        this.getDataDone = false
    },
    watch: {
        'visibility': {
            deep: true,
            handler: function (val) {
                this.step = 1
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tree-scroll{
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/pop.vue